<script>
import iApi from '../_api.js';
import _ from 'lodash';
import 'url-search-params-polyfill';

let urlParams = new URLSearchParams(window.location.search);
let region_id = null;
let sport_id = null;
let intake_year = null;
let progression_intake_id = null;

if (urlParams.has('region_id')) region_id = urlParams.get('region_id');
if (urlParams.has('sport_id')) sport_id = urlParams.get('sport_id');
if (urlParams.has('intake_year')) intake_year = urlParams.get('intake_year');
if (urlParams.has('progression_intake_id')) progression_intake_id = urlParams.get('progression_intake_id');

export default {
  name: 'competitions',

  mixins: [iApi],

  data() {
    return {
      home_url: home_url,
      competitions: null,
      sports: [],
      regions: [],
      filters: {
        region_id: region_id,
        sport_id: sport_id,
        intake_year: intake_year,
        progression_intake_id: progression_intake_id,
      },
      isLoading: true,
    }
  },

  template: `
    <div class="dash-public-plugin-container dash-public-plugin-competitions" v-bind:class="{'is-loading': isLoading}">
        <div class="dash-public-plugin-filtering">
          <div>
            <select class="competition-regions" :disabled="isLoading"></select>
          </div>
          <div>
            <select class="competition-sports" :disabled="isLoading"></select>
          </div>
          <div>
            <select class="competition-year" :disabled="isLoading"></select>
          </div>
        </div>

        <div v-if="competitions && competitions.length > 0" class="dash-list-items">
          <a
              v-for="competition in competitions"
              v-bind:key="competition.id"
              :href="home_url + '/competitions/' + competition.id"
              class="dash-list-item">
              <div class="item-content">
                <div class="item-title">{{ competition.display_name }}</div>
                <i aria-hidden="true" class="far fa-chevron-right"></i>
              </div>
          </a>
        </div>

        <div v-else>
          <p>No competitions found</p>
        </div>
    </div>
  `,

  mounted() {
    const $this = this;

    $this.getCompetitions();

    const currentYear = new Date().getFullYear(),
      endYear = (currentYear + 1);

    let yearsList = [{ id: '', text: 'All Years' }],
      startYear = (currentYear - 1);

    while (startYear <= endYear) {
      yearsList.push({
        id: startYear.toString(),
        text: startYear.toString(),
        selected: startYear.toString() == $this.filters.intake_year,
      });
      startYear++;
    }

    jQuery('.competition-year').val($this.filters.intake_year);

    const yearsDropdown = jQuery('.competition-year').select2({
      placeholder: 'All Years',
      data: yearsList,
      allowClear: true,
    });

    yearsDropdown.on('change', function (e) {
      $this.isLoading = true;
      $this.filters.intake_year = e.target.value;
      $this.getCompetitions();
    });

    jQuery('.competition-regions').on('change', function (e) {
      $this.isLoading = true;
      $this.filters.region_id = e.target.value;
      $this.getCompetitions();
    });

    jQuery('.competition-sports').on('change', function (e) {
      $this.isLoading = true;
      $this.filters.sport_id = e.target.value;
      $this.getCompetitions();
    });
  },

  methods: {
    getCompetitions: function () {
      const $this = this;
      const data = this.getCompetitionParams();

      jQuery.when(
        this.callApi('GET', '/competitions/my', data, function (result) {
          $this.competitions = _.sortBy(result, 'display_name');
        }, function (error) {
          $this.isError = true;
          $this.isLoading = false;
        }),
        this.callApi('GET', '/sports/', null, function (result) {
          $this.sports = result;
        }, function (error) {
          $this.isError = true;
          $this.isLoading = false;
        }),
        this.callApi('GET', '/regions/my', null, function (result) {
          $this.regions = result;
        }, function (error) {
          $this.isError = true;
          $this.isLoading = false;
        })
      ).then(function (results) {
        $this.isLoading = false;
      });
    },

    getCompetitionParams: function () {
      let params = {};

      if (this.filters.sport_id) params.sport_id = this.filters.sport_id;
      if (this.filters.region_id) params.region_id = this.filters.region_id;
      if (this.filters.intake_year) params.intake_year = this.filters.intake_year;
      if (this.filters.progression_intake_id) params.progression_intake_id = this.filters.progression_intake_id;

      this.setQueryVars();

      return params;
    },

    setQueryVars: function () {
      let params = {};

      if (this.filters.sport_id) params.sport_id = this.filters.sport_id;
      if (this.filters.region_id) params.region_id = this.filters.region_id;
      if (this.filters.intake_year) params.intake_year = this.filters.intake_year;
      if (this.filters.progression_intake_id) params.progression_intake_id = this.filters.progression_intake_id;

      let queryString = jQuery.param(params);

      history.pushState(null, null, '?' + queryString);
    }
  },

  watch: {
    regions: function (value) {
      if (!value) return;

      const $this = this;
      let regions = [{
        id: '',
        text: 'All Regions',
        level: 1,
      }];

      function create_region_node(region, level) {
        return {
          id: region.id,
          text: '-'.repeat(level * 2) + ' ' + region.title,
          level: level,
          selected: region.id == $this.filters.region_id,
        };
      }

      function recursive_regions(regions, result, level) {
        regions.forEach((region) => {
          result.push(create_region_node(region, level));
          if (region.regions && region.regions.length > 0)
            recursive_regions(region.regions, result, level + 1);
        });
      }

      recursive_regions(this.regions, regions, 0);

      jQuery('.competition-regions').select2({
        placeholder: 'All Regions',
        data: regions,
        allowClear: true,
        formatSelection: function (item) {
          return item.text
        },
        formatResult: function (item) {
          return item.text
        },
      });
    },

    sports: function (value) {
      if (!value) return;

      const $this = this;
      const sports = [{
        id: '',
        text: 'All Sports'
      }];

      this.sports.map(function (sport) {
        sports.push({
          id: sport.id,
          text: sport.id,
          selected: sport.id === $this.filters.sport_id,
        })
      });

      jQuery('.competition-sports').select2({
        placeholder: 'All Sports',
        data: sports,
        allowClear: true,
      });
    },
  }
}
</script>

<style scoped>

</style>
